import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

// Full-bleed atmospheric divider — barge on the water, slow scroll parallax.
export default function HammerDivider() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-7%', '7%']);

  return (
    <div
      ref={ref}
      data-testid="hammer-divider"
      className="relative h-[42vh] sm:h-[55vh] md:h-[68vh] overflow-hidden"
    >
      <motion.img
        src="/assets/barge_atmospheric.webp"
        alt="Absolute Marine Equipment work barge silhouetted on the water"
        className="absolute inset-x-0 -top-[9%] w-full h-[118%] object-cover"
        style={{ y }}
      />
      <div className="absolute inset-0 bg-black/25 pointer-events-none" />
      {/* Feathered edges — melt into the black page like the barges divider */}
      <div className="absolute inset-x-0 top-0 h-24 sm:h-36 bg-gradient-to-b from-black via-black/60 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-24 sm:h-36 bg-gradient-to-t from-black via-black/60 to-transparent pointer-events-none" />
    </div>
  );
}
